import { FIELD_UNIQUE_ID_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useMultiActivityFormStore } from "PFApp/stores/activity_form/multi_roles_form";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { useWatch } from "react-hook-form";

export const useFormActivityCreator = (roleFormKey: RoleFormKey) => {
  const uniqueRoleId = useWatch({ name: `${roleFormKey}.${FIELD_UNIQUE_ID_KEY}` });
  return useMultiActivityFormStore((store) => store.roles[uniqueRoleId]?.activityCreator ?? null);
};
